import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
// Firebase configuration
// TODO: Replace with your actual Firebase config from Firebase Console
// Go to: Firebase Console → Project Settings → General → Your apps → Web app
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'YOUR_API_KEY',
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'raja-portfolio-dad3c.firebaseapp.com',
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'raja-portfolio-dad3c',
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'raja-portfolio-dad3c.appspot.com',
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || 'YOUR_SENDER_ID',
//   appId: process.env.REACT_APP_FIREBASE_APP_ID || 'YOUR_APP_ID',
//   measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'YOUR_MEASUREMENT_ID',
// };
const firebaseConfig = {
    apiKey: "AIzaSyDNFtSh8n8m-sUqcd9YTBh4gUUMUbCa7sE",
    authDomain: "raja-portfolio-dad3c.firebaseapp.com",
    projectId: "raja-portfolio-dad3c",
    storageBucket: "raja-portfolio-dad3c.firebasestorage.app",
    messagingSenderId: "385744684108",
    appId: "1:385744684108:web:005fff46d77d2485b9a0e9",
    measurementId: "G-NS9DPEC7RP"
};
// Initialize Firebase
let app;
if (getApps().length === 0) {
    app = initializeApp(firebaseConfig);
}
else {
    app = getApps()[0];
}
// Initialize Analytics (only on client side)
let analytics = null;
if (typeof window !== 'undefined') {
    isSupported().then((supported) => {
        if (supported) {
            analytics = getAnalytics(app);
        }
    });
}
export { app, analytics };
export default app;
